import Query from './src/Query'
import QuerySelect from './src/QuerySelect'
import QueryInput from './src/QueryInput'
import QueryDatePicker from './src/QueryDatePicker'
const install = (Vue) => {
  Vue.component(Query.name, Query)
  Vue.component(QuerySelect.name, QuerySelect)
  Vue.component(QueryInput.name, QueryInput)
  Vue.component(QueryDatePicker.name, QueryDatePicker)
}
export default {
  install
}
